import { Suspense, lazy } from "react";
import styled from "styled-components";

const MainSearch = lazy(() => import("@/components/MainSearch"));

const SearchBanner = ({ lang, $isWhite, isHome, title }) => {
  return (
    <Wrapper
      className={`home-search ${isHome ? "home-bottom" : ""}`}
      $logged={true}
      $isWhite={$isWhite}
      $isHome={isHome}
    >
      {isHome ? (
        <IsHomeSearchWrapper>
          <Title className="text-center">
            {title ? title : lang?.home?.mainsearch?.titleArticle}
          </Title>
          <Suspense fallback={<div style={{ height: '38px', width: '100%' }} />}>
            <MainSearch
              lang={lang}
              modeBanner={!isHome}
              isFirst={false}
              isHome={isHome}
              id="search-banner-home"
            />
          </Suspense>
        </IsHomeSearchWrapper>
      ) : (
        <Suspense fallback={<div style={{ height: '38px', width: '100%' }} />}>
          <MainSearch
            lang={lang}
            modeBanner={!isHome}
            isFirst={false}
            isHome={isHome}
            id="search-banner"
          />
        </Suspense>
      )}
    </Wrapper>
  );
};

export default SearchBanner;

const IsHomeSearchWrapper = styled.div`
  max-width: 1400px;
  display: flex;
  flex-direction: column;
  padding: 0;
  width: calc(100% - 16px);
  @media screen and (min-width: 760px) {
    flex-direction: row;
    width: calc(100% - 64px);
    max-width: 1024px;
  }
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  > h2 {
    flex: 1 0 45%;
    color: ${(props) => props.theme.colors.white};
  }
  > form {
    flex: 0 1 45%;
    button {
      outline: 1px solid rgba(255, 255, 255, 0.7);
    }
    label {
      width: 100% !important;
    }
  }
`;

const Title = styled.h2`
  font-size: 2.6rem;
  margin-bottom: 24px;
  @media screen and (min-width: 760px) {
    font-size: 3.2rem;
  }
  color: ${(props) => props.theme.colors.blue};
  font-weight: normal;
  white-space: break-spaces;
`;

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  flex-direction: column;
  display: flex;
  gap: 12px;
  align-items: center;
  padding: ${(props) => (props.$isHome ? "16px 9px" : "5px 9px")};
  @media screen and (min-width: 798px) {
    padding: ${(props) => (props.$isHome ? "32px 18px" : "10px 18px")};
  }
  margin: 0 auto;
  background-color: ${({ $isWhite, theme }) =>
    $isWhite ? theme.colors.white : theme.colors.blue};

  ${(props) =>
    props.$isHome
      ? `
    margin: 0 auto;

    form {
      max-width: 780px;
    }
  `
      : `
    @media screen and (min-width: 798px) {
      flex-direction: row;
    }
  `}
  border-top: 1px solid
    ${({ $isWhite, theme }) =>
    $isWhite ? theme.colors.grey : theme.colors.blue};
  border-bottom: 1px solid hsla(0, 0%, 100%, 0.35);
  position: relative;
  //z-index: 5;

  form {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: ${(props) => (props.$isHome ? "24px" : "12px")};
    width: 100%;
    margin: 0 auto;

    ${(props) =>
      !props.$isHome &&
      `
      @media screen and (min-width: 798px) {
        flex-direction: row;
      }
    `}
  }

  label {
    display: inline-flex;
    flex: 0 1 auto;
    width: 100%;
    @media screen and (min-width: 798px) {
      width: 300px;
      max-width: 100%;
    }
    > div {
      width: 100%;
    }
  }

  input {
    width: 100%;
    flex: 1 1 auto;
    font-size: 1rem;
    font-weight: 400;
    height: 20px;
    line-height: 1.2;
    margin: 5px 10px 5px 0;
    padding: 10px;
    background-color: ${(props) => props.theme.colors.white};
    border: 1px solid ${(props) => props.theme.colors.greyDark};
    width: auto;
  }
`;

// const SearchLabel = styled.h1`
//   color: ${({ $isWhite, theme }) =>
//     $isWhite ? theme.colors.dark : theme.colors.white};
//   font-weight: 400;
//   font-size: 1.2rem;
//   @media screen and (min-width: 768px) {
//     font-size: 1.6rem;
//   }
// `;
